import { render } from "./FooterNavIcon.vue?vue&type=template&id=266253fc&scoped=true"
import script from "./FooterNavIcon.vue?vue&type=script&lang=js"
export * from "./FooterNavIcon.vue?vue&type=script&lang=js"

import "./FooterNavIcon.vue?vue&type=style&index=0&id=266253fc&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-266253fc"]])

export default __exports__